import React from "react";
import { CircularProgress, Typography } from "@mui/material";
import ScienceIcon from "@mui/icons-material/Science";
import BarChartIcon from "@mui/icons-material/BarChart";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import EngineeringIcon from "@mui/icons-material/Engineering";
import { CreateDocument } from "api/DocumentAPI";

const PAPER_TYPES = [
  {
    type: "research",
    label: "Research Paper",
    description: "Hypothesis-driven with citations",
    Icon: ScienceIcon,
    color: "#1565C0",
    bg: "#e8f0fe",
  },
  {
    type: "business",
    label: "Business Report",
    description: "Analysis & recommendations",
    Icon: BarChartIcon,
    color: "#2E7D32",
    bg: "#e8f5e9",
  },
  {
    type: "literature",
    label: "Literature Review",
    description: "Synthesise existing research",
    Icon: MenuBookIcon,
    color: "#6A1B9A",
    bg: "#f3e5f5",
  },
  {
    type: "case-study",
    label: "Case Study",
    description: "Real-world problem analysis",
    Icon: FindInPageIcon,
    color: "#E65100",
    bg: "#fff3e0",
  },
  {
    type: "technical",
    label: "Technical Report",
    description: "Specs & documentation",
    Icon: EngineeringIcon,
    color: "#37474F",
    bg: "#eceff1",
  },
];

function StartCard() {
  const [errors, setErrors] = React.useState({});
  const [creating, setCreating] = React.useState(null);
  const { createDocument, createLoading } = CreateDocument(setErrors);

  const handleCreate = (type) => {
    setCreating(type);
    createDocument({ variables: { type } });
  };

  return (
    <div style={{ maxWidth: 1100, margin: "24px auto 0", padding: "0 24px" }}>
      <div
        style={{
          backgroundColor: "white",
          borderRadius: 12,
          padding: "20px 24px",
          boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
        }}
      >
        <Typography
          variant="caption"
          style={{
            color: "#888",
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: 1,
            display: "block",
            marginBottom: 16,
          }}
        >
          Start a new document
        </Typography>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
          {PAPER_TYPES.map(({ type, label, description, Icon, color, bg }) => (
            <div
              key={type}
              onClick={() => !createLoading && handleCreate(type)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "12px 16px",
                borderRadius: 10,
                border: "1px solid #e8e8e8",
                cursor: createLoading ? "default" : "pointer",
                flex: "1 1 180px",
                maxWidth: 240,
                transition: "all 0.15s ease",
                backgroundColor: creating === type && createLoading ? bg : "white",
              }}
              onMouseEnter={(e) => {
                if (!createLoading) {
                  e.currentTarget.style.backgroundColor = bg;
                  e.currentTarget.style.borderColor = color;
                }
              }}
              onMouseLeave={(e) => {
                if (creating !== type) {
                  e.currentTarget.style.backgroundColor = "white";
                  e.currentTarget.style.borderColor = "#e8e8e8";
                }
              }}
            >
              <div
                style={{
                  backgroundColor: bg,
                  borderRadius: 8,
                  padding: 8,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                {creating === type && createLoading ? (
                  <CircularProgress size={20} style={{ color }} />
                ) : (
                  <Icon style={{ color, fontSize: 20 }} />
                )}
              </div>
              <div>
                <Typography
                  style={{ fontWeight: 600, fontSize: "0.82rem", color: "#1a1a2e", lineHeight: 1.2 }}
                >
                  {label}
                </Typography>
                <Typography style={{ fontSize: "0.7rem", color: "#888", marginTop: 2 }}>
                  {description}
                </Typography>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default StartCard;
